document.addEventListener('DOMContentLoaded', function () {
   // Scrolling moves elements under a stationary cursor, which fires
   // synthetic mouseenter/mouseleave events and jumps the slider. Track
   // scroll state so hover handlers can ignore those. Because those events
   // are ignored, the slider can be left out of sync with whatever is
   // actually under the cursor once scrolling stops (e.g. it scrolled out
   // from under a hovered tab, or scrolled a tab in under a stationary
   // cursor). Re-sync against the real cursor position once scrolling ends.
   var isScrolling = false;
   var scrollTimeout;
   var mouseX = -1;
   var mouseY = -1;
   var syncSliderAfterScroll = [];

   document.addEventListener('mousemove', function (e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
   }, { passive: true });

   window.addEventListener('scroll', function () {
      isScrolling = true;
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
         isScrolling = false;
         syncSliderAfterScroll.forEach(function (sync) { sync(); });
      }, 100);
   }, { passive: true });

   document.querySelectorAll('.fu-tabs').forEach(function (tabsEl) {
      var tabs = tabsEl.querySelectorAll('[role="tab"]');
      var panels = tabsEl.querySelectorAll('[role="tabpanel"]');
      var nav = tabsEl.querySelector('.fu-tabs__nav');

      var slider = document.createElement('span');
      slider.className = 'fu-tabs__slider';
      slider.setAttribute('aria-hidden', 'true');
      nav.appendChild(slider);

      function moveSlider(el, instant) {
         var navRect = nav.getBoundingClientRect();
         var elRect = el.getBoundingClientRect();
         if (instant) {
            slider.style.transition = 'none';
         }
         slider.style.width = elRect.width + 'px';
         slider.style.height = elRect.height + 'px';
         slider.style.transform = 'translate(' + (elRect.left - navRect.left) + 'px, ' + (elRect.top - navRect.top) + 'px) scale(1)';
         if (instant) {
            slider.getBoundingClientRect(); // force reflow to commit position
            slider.style.transition = '';
         }
      }

      function getActiveTab() {
         return tabsEl.querySelector('.fu-tabs__tab--active');
      }

      function activate(tab) {
         tabs.forEach(function (t) {
            t.setAttribute('aria-selected', 'false');
            t.classList.remove('fu-tabs__tab--active');
         });

         panels.forEach(function (p) {
            p.setAttribute('hidden', '');
         });

         tab.setAttribute('aria-selected', 'true');
         tab.classList.add('fu-tabs__tab--active');
         moveSlider(tab);

         var panel = document.getElementById(tab.getAttribute('aria-controls'));
         if (panel) {
            panel.removeAttribute('hidden');
            panel.style.animation = 'none';
            panel.offsetHeight;
            panel.style.animation = '';
         }

         var vpScrollThreshold = 0.45;
         // if nav is below the viewport threshold, scroll it into view
         var navRect = nav.getBoundingClientRect();
         if (navRect.top > window.innerHeight * vpScrollThreshold) {
            const offset = 20 + window.innerHeight * 0.05;
            const navHeight = document.querySelector('.navbar').offsetHeight;
            const y = window.scrollY + navRect.top - offset - navHeight;
            gsap.set("html, body", { scrollBehavior: "auto" });
            gsap.to(window, { duration: 0.5, scrollTo: { y: y }, ease: "power2" });
         }

      }

      // Place slider on active tab instantly on init
      var activeTab = getActiveTab();
      if (activeTab) {
         moveSlider(activeTab, true);
      }

      // After a scroll ends, reconcile the slider with whatever is actually
      // under the cursor (which may have changed without a hover event
      // firing, since those were ignored while isScrolling was true).
      syncSliderAfterScroll.push(function () {
         var elAtPoint = document.elementFromPoint(mouseX, mouseY);
         var hoveredTab = elAtPoint ? elAtPoint.closest('[role="tab"]') : null;
         if (hoveredTab && nav.contains(hoveredTab)) {
            moveSlider(hoveredTab);
         } else {
            var active = getActiveTab();
            if (active) {
               moveSlider(active);
            }
         }
      });

      tabs.forEach(function (tab) {
         tab.addEventListener('click', function () {
            if (tab.getAttribute('aria-selected') === 'true') return;
            activate(tab);
         });

         tab.addEventListener('mouseenter', function () {
            if (isScrolling) return;
            moveSlider(tab);
         });

         tab.addEventListener('keydown', function (e) {
            var index = Array.from(tabs).indexOf(tab);
            var next;

            if (e.key === 'ArrowRight') {
               next = tabs[(index + 1) % tabs.length];
            } else if (e.key === 'ArrowLeft') {
               next = tabs[(index - 1 + tabs.length) % tabs.length];
            } else if (e.key === 'Home') {
               next = tabs[0];
            } else if (e.key === 'End') {
               next = tabs[tabs.length - 1];
            }

            if (next) {
               e.preventDefault();
               activate(next);
               next.focus();
            }
         });
      });

      // On mouse leave from nav, snap slider back to active tab
      nav.addEventListener('mouseleave', function () {
         //if (isScrolling) return;
         var active = getActiveTab();
         if (active) {
            moveSlider(active);
         }
      });

      // Reposition on resize (handles font scaling, reflow)
      window.addEventListener('resize', function () {
         var active = getActiveTab();
         if (active) {
            moveSlider(active, true);
         }
      });
   });
});
